// extracted by mini-css-extract-plugin
export var accent = "_5m-4";
export var add = "_5m-j";
export var addIcon = "_5m-k";
export var deleteIcon = "_5m-i";
export var disabled = "_5m-9";
export var ellipsis = "_5m-f";
export var error = "_5m-3";
export var form = "_5m-5";
export var hideFocus = "_5m-2";
export var icon = "_5m-7";
export var input = "_5m-e";
export var listItem = "_5m-h";
export var mediumHeight = "_5m-b";
export var noBorder = "_5m-8";
export var noRadius = "_5m-1";
export var shortHeight = "_5m-a";
export var tallHeight = "_5m-c";
export var textInput = "_5m-0";
export var vertical = "_5m-g";
export var veryTallHeight = "_5m-d";
export var widget = "_5m-6";